import copy from '../../../copy/en/common.json' with { type: 'json' };
import type { ReactNode } from "react";
import { ShieldOff } from "lucide-react";
import { Button } from "./Button.js";

export function Spinner({ size = "md" }: { size?: "md" | "lg" }) {
  return <span className={size === "lg" ? "spinner spinner--lg" : "spinner"} role="progressbar" aria-label={copy.FullPage.loading} />;
}

export function FullPageSpinner({ label = copy.FullPage.loading2 }: { label?: string }) {
  return (
    <div className="fullpage">
      <div className="fullpage__center">
        <Spinner size="lg" />
        <span>{label}</span>
      </div>
    </div>
  );
}

export function FullPageError({
  title,
  message,
  onRetry,
  children,
}: {
  title: string;
  message?: ReactNode;
  onRetry?: () => void;
  children?: ReactNode;
}) {
  return (
    <div className="fullpage">
      <div className="fullpage__card">
        <div className="fullpage__hero">
          <h1 className="fullpage__title">{title}</h1>
          {message ? <p className="fullpage__sub">{message}</p> : null}
        </div>
        <div className="row" style={{ justifyContent: "center" }}>
          {onRetry ? (
            <Button variant="primary" onClick={onRetry}>{copy.FullPage.retry}</Button>
          ) : null}
          {children}
        </div>
      </div>
    </div>
  );
}

export function AccessDeniedScreen({ message, onSignOut }: { message: string; onSignOut: () => void }) {
  return (
    <div className="fullpage">
      <div className="fullpage__card">
        <div className="fullpage__hero">
          <ShieldOff width={32} height={32} aria-hidden style={{ color: "var(--color-danger)" }} />
          <h1 className="fullpage__title">{copy.FullPage.accessDenied}</h1>
          <p className="fullpage__sub">{message}</p>
        </div>
        <div className="row" style={{ justifyContent: "center" }}>
          <Button variant="secondary" onClick={onSignOut}>{copy.FullPage.signOut}</Button>
        </div>
      </div>
    </div>
  );
}
